import { render, staticRenderFns } from "./KwertyForLearning.vue?vue&type=template&id=ee63b9f0&scoped=true"
import script from "./KwertyForLearning.vue?vue&type=script&lang=js"
export * from "./KwertyForLearning.vue?vue&type=script&lang=js"
import style0 from "./KwertyForLearning.vue?vue&type=style&index=0&id=ee63b9f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee63b9f0",
  null
  
)

export default component.exports